import { Heart, MessageSquare, Star, Users } from "lucide-react"

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function CommunityCard({
  id,
  // name,
  // description,
  // category,
  // memberCount,
  // pinnedPostsCount,
  // rating,
  // banner,
  // logo,
  onClick,
  // role,
  // lastActive,
  className = "",
  community
}) {

  const name = community.name;
  const description = community.description;
  const category = community.category;
  const memberCount = community.memberCount;
  const pinnedPostsCount = community.pinnedPostsCount;
  const rating = community.rating;
  const banner = community.coverPicture;
  const logo = community.profilePicture;
  const role = community.role;
  const lastActive = community.lastActive;

  return (
    <div
      onClick={() => onClick?.(id)}
      className={`bg-white  rounded-xl overflow-hidden hover:shadow-lg transition-all cursor-pointer group ${className}`}
    >
      {/* Banner */}
      <div className="relative h-40">
        <img
          src={banner || "/placeholder.svg?height=200&width=400"}
          alt={`${name} banner`}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />

        {/* Logo positioned for better visibility */}
        <div className="absolute bottom-0 left-0 transform translate-y-1/2 ml-6">
          <img
            src={logo || "/placeholder.svg?height=100&width=100"}
            alt={`${name} logo`}
            className="w-16 h-16 rounded-xl border-4 border-white  shadow-lg"
          />
        </div>

        {/* Category Badge */}
        <div className="absolute top-4 right-4">
          <span className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium bg-indigo-100  text-indigo-600 ">
            {capitalize(category)}
          </span>
        </div>

        {/* Role Badge (for My Communities) */}
        {role && (
          <div className="absolute top-4 left-4">
            <span
              className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium ${role === "Admin" || role === "admin"
                  ? "bg-purple-100  text-purple-600 "
                  : "bg-blue-100  text-blue-600 "
                }`}
            >
              {role}
            </span>
          </div>
        )}
      </div>

      {/* Content with improved spacing */}
      <div className="p-6 pt-10">
        <h3 className="font-semibold text-lg mb-2 group-hover:text-indigo-600 transition-colors line-clamp-1">
          {name}
        </h3>
        <p className="text-sm text-gray-600  mb-5 line-clamp-2 min-h-[2.5rem]">{description}</p>

        <div className="flex items-center justify-between text-sm mb-5">
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1.5 text-gray-500">
              <Users className="w-4 h-4" />
              {memberCount}
            </span>
            <span className="flex items-center gap-1.5 text-gray-500">
              <MessageSquare className="w-4 h-4" />
              {pinnedPostsCount || 0}
            </span>
          </div>
          <div className="flex items-center gap-1.5">
            <Star className="w-4 h-4 text-yellow-500 fill-current" />
            <span className="text-gray-700  font-medium">{rating}</span>
          </div>
        </div>

        {/* Last active (for My Communities) */}
        {lastActive && <p className="text-xs text-gray-500 mb-4">Active {lastActive}</p>}

        {/* Join/Manage Button */}
        <div className="pt-4 border-t border-gray-200 ">
          <button className="w-full flex justify-center items-center gap-2 py-2.5 px-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors">
            <Heart className="w-4 h-4" />
            <span>{role ? (role === "admin" ? "Manage Community" : "View Community") : "Join Community"}</span>
          </button>
        </div>
      </div>
    </div>
  )
}

